import React from "react";

interface ForceReloadInterface{
    forceReloadView: string|null,
    setForceReloadView: React.Dispatch<string|null>
}

const ForceReloadContext = React.createContext<ForceReloadInterface|null>(null);

export {ForceReloadContext};